import _ from '@lodash';

export function formatLabelValue(value, format, uom, label) {
    const formatter = new Intl.NumberFormat('en-US', {
        useGrouping: format.thousandsSeparator || false,
        minimumFractionDigits: 0,
        maximumFractionDigits: Number.isInteger(format.decimalPlaces) ? format.decimalPlaces : 20
    });
    if (!value || _.isNaN(value)) {
        return `${label ? `${label}: ` : ''} -`;
    }
    const convertedValue = format.displayAsPercentage ? value * 100 : value;
    const formattedValue = formatter.format(convertedValue).replaceAll(',', ' ');
    return `${label ? `${label}: ` : ''}${format.displayAsPercentage ? `${formattedValue}${format.showUnit ? ' %' : ''}` : formattedValue}${format.showUnit ? `${uom ? ` ${uom}` : ''}` : ''}`;
}

export function objArrayToMap(array, keyName, valueName) {
    // eslint-disable-next-line
    let map = {};
    if (array) for (let i = 0; i < array.length; i += 1) map[array[i][keyName]] = array[i][valueName];
    return map;
}

export function mapToObjArr(map, keyName, valueName) {
    // eslint-disable-next-line
    let array = [];
    // eslint-disable-next-line
    for (let key in map) {
        // eslint-disable-next-line
        let obj = {};
        obj[keyName] = key;
        obj[valueName] = map[key];
        array.push(obj)
    }
    return array;
}

/* copy/paste */

export function isJSON(text) { try { JSON.stringify(JSON.parse(text)); return true; } catch (e) { return false; } };

export function isXLS(text) { return text.indexOf('	') > -1 };

export function tsvJSONLegacy(tsv) {
    const lines = tsv.split('\n');
    // eslint-disable-next-line
    let obj = {};
    for (let i = 0; i < lines.length; i += 1) {
        if (lines[i] !== '') {
            // eslint-disable-next-line
            let line = lines[i].replace('\r', '').split('\t');
            // eslint-disable-next-line
            obj[line[0]] = line[1];
        }
    }
    return obj;
}

export function tsvJSON(tsv) {
    const lines = tsv.split('\n');

    // eslint-disable-next-line
    let obj = {};
    // eslint-disable-next-line
    let arr = [];

    for (let i = 0; i < lines.length; i += 1)
        if (lines[i] !== '')
            arr.push(lines[i].replace('\r', '').split('\t'));

    for (let i = 1; i < arr.length; i += 1) {
        obj[arr[i][0]] = {};
        for (let j = 1; j < arr[i].length; j += 1)
            obj[arr[i][0]][arr[0][j]] = arr[i][j];
    }

    return obj;
}

export function getQueriedSelection(service, query, limit) {
    const filterByQuery = (l, q) => {
        if (!l) return [];
        if (!q || q === '') return l;
        if (q.startsWith('#')) return l.filter(item => item.id === parseInt(q.replace('#', ''), 10));
        return l.filter(item => item.name.toLowerCase().includes(q.toLowerCase()));
    };
    return new Promise((resolve, reject) => {
        service.then(resp => {
            resolve(filterByQuery(resp, query));
        }).catch(e => reject(e));
    });
}